
import { MapTo } from '@adobe/aem-react-editable-components';
import BrandProduct, { BrandProductEditConfig } from './BrandProduct';

export default MapTo('cob-corp-acquisition/components/creditonebank/brand-product')(BrandProduct, BrandProductEditConfig);
        